import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Twc extends Element {
  constructor (attrs) {
    super(attrs)
    // Status properties
    this.radio = !!this.statusBit(0)
  }

  setDefaultShapes () {
    this.shapes.push(
      new Ren.Circle({
        name: 'twc',
        x: 0,
        y: 0,
        radius: 8,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.5
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // radio
    if (status.radio) {
      this.modifyShape('twc', 'fill', Color.tBlue)
    }
  }
}
